"use client";

import Button from 'src/components/button/Button';
import { getMovieChartText } from 'src/components/kinotoppen/kinotoppenHelpers';
import { ChartType } from 'src/lib/client/useMovieChart';
import { useState } from 'react';
import styles from './MovieChartTypeSelector.module.css';

//#region [Props]
type MovieChartSelectorProps = {
    chartType: ChartType;
    setChartType: (chartType: ChartType) => void;
};
//#endregion

//#region [Component]
export default function MovieChartSelector({ chartType, setChartType }: MovieChartSelectorProps) {
    const [showPeriodOptions, setShowPeriodOptions] = useState(false);

    const typeHandler = (ct: ChartType) => {
        setShowPeriodOptions(false);
        setChartType(ct);
    };

    return <div className={styles.SMovieChartSelector}>
        <Button className={styles.SButton}
            text={getMovieChartText(chartType)}
            onClick={() => setShowPeriodOptions(!showPeriodOptions)}
            role="combobox"
            aria-labelledby="select button"
            aria-haspopup="listbox"
            aria-expanded={showPeriodOptions}
            aria-controls="select-dropdown"
        />

        {showPeriodOptions && <div className={styles.SOptionsContainer}>
            <label className={styles.SLabel} htmlFor='select-dropdown'>Velg tidsrom</label>
            <ul className={styles.SMovieChartOptions} role='listbox' id="select-dropdown">
                <li className={styles.SOption} role='option' aria-selected={chartType === "weekend"} onClick={() => typeHandler("weekend")} >Helg</li>
                <li className={styles.SOption} role='option' aria-selected={chartType === "week"} onClick={() => typeHandler("week")}>Uke</li>
                <li className={styles.SOption} role='option' aria-selected={chartType === "year"} onClick={() => typeHandler("year")}>År</li>
                <li className={styles.SOption} role='option' aria-selected={chartType === "opening"} onClick={() => typeHandler("opening")}>Åpningshelger</li>
            </ul>
        </div>}
    </div>;
}
//#endregion

//#region [Styles]
//#endregion

